/**
 * Per-block render module registry (NOS-151).
 *
 * BlockRenderer is a thin dispatcher over this map — every block type renders
 * from its module in this directory.
 */
import type { FC } from "react"
import type { BlockType } from "@/components/website-builder/blocks/types"
import type { BlockComponentProps } from "./shared"
import { HeroBlock } from "./hero"
import { ImpactStatsBlock } from "./impact_stats"
import { DonationCtaBlock } from "./donation_cta"
import { FooterBlock } from "./footer"
import { ParagraphBlock } from "./paragraph"
import { HeadingBlock } from "./heading"
import { ImageBlock } from "./image"
import { TeamMembersBlock } from "./team_members"
import { TimelineBlock } from "./timeline"
import { FormBlock } from "./form"
import { TestimonialsBlock } from "./testimonials"
import { VolunteerSignupBlock } from "./volunteer_signup"
import { GalleryBlock } from "./gallery"
import { ContactBlock } from "./contact"
import { AccordionBlock } from "./accordion"
import { CardsBlock } from "./cards"
import { LogoGridBlock } from "./logo_grid"
import { TableBlock } from "./table"
import { FundraisingGoalBlock } from "./fundraising_goal"
import { ListBlock } from "./list"
import { BlockquoteBlock } from "./blockquote"
import { VideoBlock } from "./video"
import { CalloutBlock } from "./callout"
import { ImageTextBlock } from "./image_text"
import { PullQuoteBlock } from "./pull_quote"
import { DividerBlock } from "./divider"
import { ButtonBlock } from "./button"
import { FileDownloadBlock } from "./file_download"
import { EmbedBlock } from "./embed"
import { NewsletterSignupBlock } from "./newsletter_signup"
import { DonationFormBlock } from "./donation_form"
import { CampaignBannerBlock } from "./campaign_banner"
import { AuthorBioBlock } from "./author_bio"
import { MapBlock } from "./map"
import { LatestPostsBlock } from "./latest_posts"

export type { BlockComponentProps } from "./shared"

export const BLOCK_COMPONENTS: Partial<Record<BlockType, FC<BlockComponentProps>>> = {
  hero: HeroBlock,
  impact_stats: ImpactStatsBlock,
  donation_cta: DonationCtaBlock,
  footer: FooterBlock,
  paragraph: ParagraphBlock,
  heading: HeadingBlock,
  image: ImageBlock,
  team_members: TeamMembersBlock,
  timeline: TimelineBlock,
  form: FormBlock,
  testimonials: TestimonialsBlock,
  volunteer_signup: VolunteerSignupBlock,
  gallery: GalleryBlock,
  contact: ContactBlock,
  accordion: AccordionBlock,
  cards: CardsBlock,
  logo_grid: LogoGridBlock,
  table: TableBlock,
  fundraising_goal: FundraisingGoalBlock,
  list: ListBlock,
  blockquote: BlockquoteBlock,
  video: VideoBlock,
  callout: CalloutBlock,
  image_text: ImageTextBlock,
  pull_quote: PullQuoteBlock,
  divider: DividerBlock,
  button: ButtonBlock,
  file_download: FileDownloadBlock,
  embed: EmbedBlock,
  newsletter_signup: NewsletterSignupBlock,
  donation_form: DonationFormBlock,
  campaign_banner: CampaignBannerBlock,
  author_bio: AuthorBioBlock,
  map: MapBlock,
  latest_posts: LatestPostsBlock,
}
